import { render, staticRenderFns } from "./CustomNumber.vue?vue&type=template&id=3f3809e4&scoped=true&"
import script from "./CustomNumber.vue?vue&type=script&lang=js&"
export * from "./CustomNumber.vue?vue&type=script&lang=js&"
import style0 from "./CustomNumber.vue?vue&type=style&index=0&id=3f3809e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3809e4",
  null
  
)

export default component.exports